export default __webpack_public_path__ + "static/media/shareholders.91d5304e.svg";